import type { CookieService } from "@/src/infrastructure/cookieconsent/CookieService";

import { CookieCategory } from "@/src/infrastructure/cookieconsent/CookieCategory";

export const surveyCookie: CookieService<CookieCategory.NECESSARY> = {
  category: CookieCategory.NECESSARY,
  name: "SurveyJS",
  purpose: "Questionnaires produits",
  // No privacyPolicyUrl: this cookie is first-party (set by our own backend,
  // see createSurveyResultUseCase.ts). SurveyJS itself never sees it, so
  // there is no separate third-party data controller to link to.
};
